import { clamp, roundToNearest } from "@/lib/utils";

export function perServingToPct(
  valueGrams: number,
  gramsPerServing: number,
): number {
  if (
    !Number.isFinite(valueGrams) ||
    !Number.isFinite(gramsPerServing) ||
    gramsPerServing <= 0
  ) {
    return 0;
  }

  return clamp((valueGrams / gramsPerServing) * 100, 0, 100);
}

export function kcalPerServingToKcalPerGram(
  caloriesPerServing: number,
  gramsPerServing: number,
): number {
  if (
    !Number.isFinite(caloriesPerServing) ||
    !Number.isFinite(gramsPerServing) ||
    gramsPerServing <= 0
  ) {
    return 0;
  }

  return Math.max(caloriesPerServing / gramsPerServing, 0);
}

export function deriveWaterRemainder(parts: number[]): number {
  const nutritionalComponents = parts.reduce(
    (sum, part) => sum + (Number.isFinite(part) ? part : 0),
    0,
  );
  return clamp(roundToNearest(100 - nutritionalComponents, 0.1), 0, 100);
}
